module.exports = __webpack_public_path__ + "static/media/cvdownload.30fb2c75.png";